<template>
  <div id="app">
    <v-app>
      <router-view :key="$route.name"/>
      <notifications group="booking" />
      <v-dialog v-model="ageRestrictionDialog"
        persistent
        max-width="400"
      >
        <v-card>
          <v-card-title class="text-h5">
           Are you over&nbsp;{{ config.patientMinAge }}?
          </v-card-title>
          <v-card-text>{{ config.patientMinAgeMessage }}</v-card-text>
          <v-card-actions>
            <v-btn
                color="primary"
                text
                @click="dialogAgeGoBack"
            >
              No, go back
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                text
                @click="dialogAgeProceed"
            >
              Yes, proceed
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-app>
    <!-- Google Tag Manager (noscript) -->
    <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KK8V8S2"
                      height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
    <!-- End Google Tag Manager (noscript) -->
  </div>
</template>

<script>
  import config from '@/config'
  import { ref } from '@vue/composition-api'

  export default {
    setup() {
      const initGoogle = () => {
          (function (w, d, s, l, i) {
          w[l] = w[l] || [];
          w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
          var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
          j.async = true;
          j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
          f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', config.googleGTM);
      }

      if (config.googleGTM) {
        initGoogle()
      }

      const initZohoChat = () => {
        window.$zoho = window.$zoho || {}
        window.$zoho.salesiq = window.$zoho.salesiq || {
          widgetcode: config.zohoChatWidgetCode,
          values: {},
          ready:function(){}
        }
        const d = document
        const s = d.createElement('script')
        s.type = 'text/javascript'
        s.id = 'zsiqscript'
        s.defer = true
        s.src = 'https://salesiq.zoho.eu/widget'
        const t = d.getElementsByTagName('script')[0]
        t.parentNode.insertBefore(s, t);
      }

      if (config.zohoChatWidgetCode) {
        initZohoChat()
      }

      const ageRestrictionDialog = ref(!!config.patientMinAge)

      const dialogAgeProceed = () => {
        ageRestrictionDialog.value = false
      }

      const dialogAgeGoBack = () => {
        window.history.back()
      }

      return {
        ageRestrictionDialog,
        dialogAgeProceed,
        dialogAgeGoBack,
        config
      }
    }
  }
</script>
